import PropertyCard, {
  PropertyCardContent,
  PropertyCardContentProps,
  PropertyCardProps
} from '@portalterreno/nextjs-client/portalterreno/components/PropertyCard';
import React from 'react';

import { Pricing } from '../../../types';
import StyledLink from './StyledLink';

export type RelatedPropertyCardProps = Pick<
  PropertyCardProps,
  'surfaceLabel' | 'cityName' | 'communeName'
> &
  Pick<PropertyCardContentProps, 'epigraph'> & {
    cityName: string;
    title: string;
    propertyLogo?: string | null;
    principalCurrency: string;
    surface: number;
    surfaceUnit: string;
    photoCover: string;
    pricing: Pricing;
    url: string;
    chips: Array<string>;
  };

const RelatedPropertyCard: React.FC<RelatedPropertyCardProps> = ({
  title,
  propertyLogo,
  principalCurrency,
  surface,
  surfaceUnit,
  photoCover,
  pricing,
  url,
  chips,
  epigraph,
  ...rest
}) => {
  return (
    <StyledLink
      href={url}
      className='related-card'
    >
      <PropertyCard
        chips={chips}
        image={photoCover}
        surface={surface}
        surfaceUnit={surfaceUnit}
        {...rest}
      >
        <PropertyCardContent
          currency={principalCurrency}
          epigraph={epigraph}
          location={title}
          logo={propertyLogo}
          pricing={pricing}
        />
      </PropertyCard>
    </StyledLink>
  );
};

export default React.memo(RelatedPropertyCard);
